var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedirectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63386",
    "data-name": "Group 63386",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221874",
    "data-name": "Path 221874",
    d: "M14.364,8a.636.636,0,0,0-.636.636v3.818a1.273,1.273,0,0,1-1.273,1.273H3.545a1.273,1.273,0,0,1-1.273-1.273V3.545A1.273,1.273,0,0,1,3.545,2.273H7.364A.636.636,0,0,0,7.364,1H3.545A2.545,2.545,0,0,0,1,3.545v8.909A2.545,2.545,0,0,0,3.545,15h8.909A2.545,2.545,0,0,0,15,12.455V8.636A.636.636,0,0,0,14.364,8Z",
    transform: "translate(0 0)",
    fill: "#237c9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221875",
    "data-name": "Path 221875",
    d: "M18.985,1.393a.633.633,0,0,0-.119-.178c-.008-.008-.01-.019-.019-.028s-.019-.011-.028-.019A.6.6,0,0,0,18.4,1H14.558a.64.64,0,0,0,0,1.279h2.293L12.187,6.943a.64.64,0,1,0,.9.9l4.664-4.664V5.477a.64.64,0,1,0,1.279,0V1.64A.633.633,0,0,0,18.985,1.393Z",
    transform: "translate(-4.035 0)",
    fill: "#237c9d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectionIcon);
export default __webpack_public_path__ + "static/media/redirectionIcon.4967e22a92a8a3442f6bb01ee97fb235.svg";
export { ForwardRef as ReactComponent };